<script lang="ts">
    export let contentEntry: ContentEntry
</script>

<section class="tp-xl bp-xl news-title">
    <div class="container">
        {#if contentEntry.news?.date}
            <h3>
                <!-- formate date by browser language -->
                {new Date(contentEntry.news?.date).toLocaleDateString(undefined, {
                    month: "long",
                    day: "numeric",
                    year: "numeric",
                })}
            </h3>
        {/if}
        <h1 class="h2">{contentEntry.news?.title || ""}</h1>
    </div>
</section>
